import React from "react";
import { FaSearch } from "react-icons/fa";

// TODO iconが違うのと、focusのborder変化が少しへん
const SearchInput = ({
  placeholder = "",
  setValue,
  value = "",
}: {
  placeholder: string;
  setValue: (_: string) => void;
  value: string;
}) => {
  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
  };
  return (
    <form className="relative flex w-full focus-within:border-link focus-within:ring-link">
      <FaSearch size={20} color="#706D65" className="absolute left-[15px] top-[15px]" />
      <input
        value={value}
        onChange={(e) => setValue(e.target.value)}
        className="h-12 flex-grow rounded border border-input-normal bg-input-normal px-4 pl-[40px] placeholder:text-input-placeholder focus:bg-link-light focus:shadow-input focus:outline-none"
        placeholder={placeholder}
        onKeyDown={(e) => handleKeyDown(e)}
      />
    </form>
  );
};

export default SearchInput;
